// Recovered compiled webpack factory 39622. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { ge: () => o, xU: () => s });
  let n = () => ({ translate: 0, scale: 1, origin: 0, originPoint: 0 }),
    s = () => ({ x: n(), y: n() }),
    r = () => ({ min: 0, max: 0 }),
    o = () => ({ x: r(), y: r() });
}
